"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Select = _interopRequireDefault(require("@material-ui/core/Select"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _Input = _interopRequireDefault(require("@material-ui/core/Input"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _AnalyticsWrapper = _interopRequireDefault(require("../Analytics/AnalyticsWrapper"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _root;
  return {
    formControl: _defineProperty({
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      marginRight: theme.spacing(3),
      minWidth: 150,
      maxWidth: 500
    }, theme.breakpoints.down('xs'), {
      marginRight: theme.spacing(1),
      '& .MuiInput-root': {
        maxWidth: 144
      }
    }),
    root: (_root = {
      display: 'flex',
      maxWidth: 'calc(100% - 40px)'
    }, _defineProperty(_root, theme.breakpoints.up('sm'), {
      maxWidth: 'calc(100% - 160px)' // subtract the full menu width
    }), _defineProperty(_root, theme.breakpoints.between('xs', 'sm'), {
      display: 'flex',
      alignItems: 'center'
    }), _root),
    typographyBody: _defineProperty({
      fontWeight: 'bold',
      fontSize: 15,
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      marginRight: 5,
      lineHeight: '18px',
      textAlign: 'center',
      letterSpacing: 'unset',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }, theme.breakpoints.down('sm'), {
      fontSize: 12
    }),
    fontWeightNormal: {
      fontWeight: 'normal'
    },
    typoLineHeight: {
      marginLeft: 24
    },
    variantThumbnail: {
      width: 50,
      height: 50,
      maxHeight: '100%',
      maxWidth: '100%'
    },
    menuItemRoot: {
      whiteSpace: 'unset',
      height: 76,
      width: 220
    },
    selectedListItem: {
      '& span': {
        fontWeight: 'bold',
        letterSpacing: 'unset'
      }
    },
    arrowNone: {
      display: 'none'
    },
    itemInfoWrapper: _defineProperty({
      display: 'inline-flex',
      alignItems: 'center'
    }, theme.breakpoints.down('sm'), {
      display: 'block',
      maxWidth: '100%',
      overflow: 'hidden',
      '& p': {
        marginLeft: 0,
        display: 'block',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'start'
      }
    }),
    variantList: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textTransform: 'capitalize',
      paddingLeft: 16,
      '& span': {
        fontSize: '15px',
        lineHeight: '22px',
        letterSpacing: 'unset',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    },
    selectInputUnderline: {
      '&:after': {
        borderBottom: '2px solid ' + theme.palette.primary.main
      }
    },
    selectMenu: {
      '& img': {
        display: 'none'
      },
      '& div': {
        '& span': {
          fontSize: '15px',
          fontWeight: 'bold'
        }
      }
    }
  };
};
var ITEM_HEIGHT = 55;
var ITEM_PADDING_TOP = 15;
var MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 7 + ITEM_PADDING_TOP,
      width: 220,
      top: 55
    }
  }
};
var VariantChooser = /*#__PURE__*/function (_React$Component) {
  _inherits(VariantChooser, _React$Component);
  var _super = _createSuper(VariantChooser);
  function VariantChooser() {
    _classCallCheck(this, VariantChooser);
    return _super.apply(this, arguments);
  }
  _createClass(VariantChooser, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classes = _this$props.classes,
        value = _this$props.value,
        variants = _this$props.variants,
        handleChange = _this$props.handleChange,
        title = _this$props.title,
        renderExtraInfo = _this$props.renderExtraInfo;
      var multipleVariants = variants.length > 1;
      var arrowVisible = !multipleVariants ? classes.arrowNone : '';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.root
      }, variants.length > 1 && /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        className: classes.formControl
      }, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
        targetId: "change_variant"
      }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        value: value,
        onChange: handleChange,
        input: /*#__PURE__*/_react["default"].createElement(_Input["default"], {
          id: "variantInput",
          classes: {
            underline: classes.selectInputUnderline
          }
        }),
        MenuProps: MenuProps,
        classes: {
          selectMenu: classes.selectMenu,
          icon: arrowVisible
        }
      }, variants.map(function (variant) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: variant.key,
          value: variant.value,
          "aria-label": variant.title,
          classes: {
            selected: classes.selectedListItem
          },
          className: classes.menuItemRoot
        }, variant.url && /*#__PURE__*/_react["default"].createElement("img", {
          src: variant.url,
          alt: variant.title,
          "aria-label": variant.title,
          className: classes.variantThumbnail
        }), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
          className: classes.variantList,
          primary: variant.title
        }));
      })))), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.itemInfoWrapper
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        classes: {
          body2: classes.typographyBody
        },
        component: "p",
        variant: "body2"
      }, title), renderExtraInfo && renderExtraInfo(this.props)));
    }
  }]);
  return VariantChooser;
}(_react["default"].Component);
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'VariantChooser'
})(VariantChooser);